import { Classes, Icon } from "@blueprintjs/core";
import { Link } from "react-router";

import { Card } from "@/components/layout/Card";
import { Box, Flex } from "@/components/layout/flexbox";
import { FlexibleButton } from "@/components/pieces/button/FlexibleButton";
import { CoachingSvg } from "@/components/pieces/icons/svg/coaching";
import { PracticeSvg } from "@/components/pieces/icons/svg/practice";
import { MIDTEXT_COLOR } from "@/css/constants";

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  subtext: string;
  bg: string;
  ctaTo: string;
  ctaText: string;
}

function FeatureCard({
  icon,
  title,
  subtext,
  bg,
  ctaTo,
  ctaText,
}: FeatureCardProps) {
  return (
    <Flex
      p={24}
      className="round-corners"
      style={{
        background: bg,
      }}
      flex={[undefined, undefined, 1]}
      width={["100%", "100%", "100%", "auto"]}
      flexDirection="column"
      justifyContent="space-between"
    >
      <Flex css={{ gap: 10 }} flexDirection={["row", "row", "row", "column"]}>
        <Box minWidth={24}>{icon}</Box>
        <Box>
          <Box fontSize={18} fontWeight={600}>
            {title}
          </Box>
          <Box
            mt={2}
            fontSize={14}
            color={MIDTEXT_COLOR}
            className={Classes.RUNNING_TEXT}
          >
            {subtext}
          </Box>
        </Box>
      </Flex>
      <Box mt={24}>
        <FlexibleButton as={Link} to={ctaTo} variant="white" fill={true}>
          {ctaText}
        </FlexibleButton>
      </Box>
    </Flex>
  );
}

export function GetStartedCard() {
  return (
    <Card className="bas" elevation={1} p={0}>
      <Flex
        css={{ gap: 24 }}
        p={24}
        flexDirection={["column", "column", "column", "row"]}
      >
        <FeatureCard
          title="Work With a Coach"
          subtext="Get 1:1 personalized support from an expert coach"
          bg="linear-gradient(127deg, #F2FAFF 7.13%, #D8ECF8 102.77%)"
          ctaTo="/match"
          ctaText="Find My Coach"
          icon={<CoachingSvg size={24} color="#2B2165" />}
        />
        <FeatureCard
          title="Roleplay with AI"
          subtext="Practice high-stakes convos and get immediate feedback"
          bg="linear-gradient(127deg, #F3FFF6 7.13%, #DAF7F9 102.77%)"
          ctaTo="/roleplays"
          ctaText="Start Practicing"
          icon={<PracticeSvg size={24} color="#537879" />}
        />
        <FeatureCard
          title="Read Guides"
          subtext="Explore expert-written content on key leadership topics"
          bg="linear-gradient(127deg, #F3F2FF 7.13%, #D8E5F8 102.77%)"
          ctaTo="/learn"
          ctaText="Browse Guides"
          icon={<Icon icon="manual" size={24} color="#70709E" />}
        />
      </Flex>
    </Card>
  );
}
